import Vue from 'vue';
import Router from 'vue-router';
import DvdOrder from '@/dvd-orders/DvdOrder.vue';
import DvdCart from '@/dvd-orders/DvdCart.vue';
import DvdCheckout from '@/dvd-orders/DvdCheckout.vue';
import DvdConfirmation from '@/dvd-orders/DvdConfirmation.vue';
import store from '@/store';
import DvdReview from '@/dvd-orders/DvdReview.vue';

export enum Page {
    DVD_ORDER = 'dvdOrder',
    CART = 'cart',
    CHECKOUT_INFO = 'checkoutInfo',
    REVIEW = 'review',
    CONFIRMATION = 'confirmation'
}

Vue.use(Router);

const routes = [
    { path: '/', name: Page.DVD_ORDER, component: DvdOrder },
    { path: '/cart', name: Page.CART, component: DvdCart },
    { path: '/checkout', name: Page.CHECKOUT_INFO, component: DvdCheckout },
    { path: '/review', name: Page.REVIEW, component: DvdReview },
    { path: '/confirmation', name: Page.CONFIRMATION, component: DvdConfirmation }
];

const router = new Router({
    routes,
    scrollBehavior (to, from, savedPosition) {
      return { x: 0, y: 0 };
    }
});

// Ensure the user has completed all previous steps before allowing them to proceed to the next one.
router.beforeEach((to, from, next) => {
    let override = Page.DVD_ORDER;
    if (to.name === Page.CONFIRMATION) {
        if (store.state.confirmationNumber) {
            next();
            return;
        }
    } else if (to.name === Page.CART || to.name === Page.CHECKOUT_INFO) {
        if (store.state.dvdOrderDetails.items.length > 0
                || (to.query.eventIdForDvdOrder && !isNaN(Number(to.query.eventIdForDvdOrder)))
                || (to.query.dvdIdForDvdOrder && !isNaN(Number(to.query.dvdIdForDvdOrder)))) {
            next();
            return;
        }
    } else if (to.name === Page.DVD_ORDER) {
        next();
        return;
    } else if (to.name === Page.REVIEW) {
        if (store.getters.contactInfoComplete) {
            next();
            return;
        } else {
            override = Page.CHECKOUT_INFO;
        }
    }
    next({ name: override });
});

Vue.use(Router);

export default router;
